module.exports = __webpack_public_path__ + "static/media/Becoming-a-Father.5a8ae8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Becoming-a-Father.png
// module id = 130
// module chunks = 0